import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import {
  CalendarCell,
  CalendarCellProps,
  CalendarCellAlignment,
  CalendarCellTimes,
} from '..';
import { classes } from './CalendarCell.visual.st.css';

const defaultProps: CalendarCellProps = {
  title: '12',
};

visualize('CalendarCell', () => {
  story('render', () => {
    snap('title', <CalendarCell {...defaultProps} />);
    snap(
      'past date',
      <CalendarCell timeType={CalendarCellTimes.pastDate} {...defaultProps} />,
    );
    snap(
      'today',
      <CalendarCell timeType={CalendarCellTimes.today} {...defaultProps} />,
    );
    snap(
      'future date',
      <CalendarCell
        timeType={CalendarCellTimes.futureDate}
        {...defaultProps}
      />,
    );
    snap('current', <CalendarCell current {...defaultProps} />);
    snap(
      'past date and current',
      <CalendarCell
        timeType={CalendarCellTimes.pastDate}
        current
        {...defaultProps}
      />,
    );
    snap(
      'future date and current',
      <CalendarCell
        timeType={CalendarCellTimes.futureDate}
        current
        {...defaultProps}
      />,
    );
    snap('stretchable', <CalendarCell {...defaultProps} stretchable />);
    snap(
      'left',
      <CalendarCell
        alignment={CalendarCellAlignment.left}
        {...defaultProps}
        stretchable
      />,
    );
    snap(
      'center',
      <CalendarCell
        alignment={CalendarCellAlignment.center}
        {...defaultProps}
      />,
    );
    snap(
      'right',
      <CalendarCell
        alignment={CalendarCellAlignment.right}
        {...defaultProps}
      />,
    );
    snap(
      'today style overrides',
      <CalendarCell
        timeType={CalendarCellTimes.today}
        className={classes.todayOverride}
        {...defaultProps}
      />,
    );
    snap(
      'today style overrides and current',
      <CalendarCell
        current
        timeType={CalendarCellTimes.today}
        className={classes.todayOverride}
        {...defaultProps}
      />,
    );
    snap(
      'past date style overrides',
      <CalendarCell
        timeType={CalendarCellTimes.pastDate}
        className={classes.pastOverride}
        {...defaultProps}
      />,
    );
    snap(
      'past date style overrides and current',
      <CalendarCell
        current
        timeType={CalendarCellTimes.pastDate}
        className={classes.pastOverride}
        {...defaultProps}
      />,
    );
    snap(
      'future date style overrides',
      <CalendarCell
        timeType={CalendarCellTimes.futureDate}
        className={classes.futureOverride}
        {...defaultProps}
      />,
    );
    snap(
      'future date style overrides and current',
      <CalendarCell
        current
        timeType={CalendarCellTimes.futureDate}
        className={classes.futureOverride}
        {...defaultProps}
      />,
    );
  });
});
